module.exports = __webpack_public_path__ + "img/Modernisme_Spraaket_i_perioden1.deee6af4.jpg";